import { forwardRef, memo } from 'react';
import isNil from 'lodash/isNil';
import isNull from 'lodash/isNull';
import indexOf from 'lodash/indexOf';
// Material UI imports
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import List from '@mui/material/List';
// local imports
import { DrawerItem } from '../types';
import AppDrawerItem from './AppDrawerItem';
// SCSS imports
import { list } from './AppDrawer.module.scss';

type AppDrawerProps = {
  readonly items: DrawerItem[];
  readonly path?: string;
  readonly defaultLink?: string;
  readonly open?: boolean;
  readonly persistent?: boolean;
  readonly permanent?: boolean;
  readonly onOpen: () => void;
  readonly onClose: () => void;
  readonly isItemVisible?: (item: DrawerItem) => boolean;
};

const AppDrawer = forwardRef<HTMLDivElement, AppDrawerProps>(({
  items,
  path = '',
  defaultLink,
  open,
  persistent,
  permanent,
  onOpen,
  onClose,
  isItemVisible
}, ref) => (
  <SwipeableDrawer
      ref={ref}
      open={Boolean(open)}
      onOpen={onOpen}
      onClose={onClose}
      variant={(persistent && 'persistent') || (permanent && 'permanent') || undefined}
  >
    <List className={list}>
      {items.map((item) => (!isItemVisible || isItemVisible(item)) && (
        <AppDrawerItem
            key={item.text || item.link || item.href || defaultLink}
            text={item.text}
            icon={item.icon}
            link={item.link || (isNil(item.href) && isNull(item.link) ? defaultLink : undefined)}
            href={item.href}
            onClick={onClose}
            active={item.link === path || indexOf(item.paths, path) >= 0}
        />
      ))}
    </List>
  </SwipeableDrawer>
));

AppDrawer.displayName = 'AppDrawer';

export default memo(AppDrawer);
